import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Box, Typography, Grid } from '@mui/material';
import { useChart } from 'src/shared/components/chart';
import MonthlyYearlyToggle from './ToogleGraph';

AppWebsiteVisits.propTypes = {
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  content: PropTypes.string,
  orderData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
};


export default function AppWebsiteVisits({ weeklyChartLabels, monthlyChartLabels, weeklyChartData, monthlyChartData, merchant = false, ...other }) {
  const [view, setView] = useState('weekly');

  useEffect(() => {
    const interval = setInterval(() => {
      setView((prevView) => (prevView === 'weekly' ? 'monthly' : 'weekly'));
    }, 10000); // 10 seconds interval
    return () => clearInterval(interval);
  }, []);

  const handleToggle = (selectedView) => {
    setView(selectedView);
  };

  const chartOptions = useChart({
    plotOptions: {
      bar: {
        columnWidth: '20%',
      },
    },
    fill: {
      type: view === 'weekly' ? weeklyChartData.map((i) => i.fill) : monthlyChartData.map((i) => i.fill),
      opacity: 0.2,
    },
    labels: view === 'weekly' ? weeklyChartLabels : monthlyChartLabels,
    colors: merchant ? ['#9DB2CE'] : ['#9DB2CE', '#0D1E1C', '#32CA73', '#61C0C5'],
    stroke: {
      width: merchant ? [0] : [0, 3, 3, 3],
    },
    tooltip: {
      shared: true,
      intersect: false,
      style: {
        fontSize: '12px', // Adjust tooltip font size here
      },
    },
    xaxis: {
      labels: {
        style: {
          fontSize: '12px', // Adjust x-axis labels font size here
        },

      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px', // Adjust y-axis labels font size here
        },
      },
    },
    legend: {
      fontSize: '14px',
      horizontalAlign: 'left', // Align the legend to the left
      position: 'top',
      labels: {
        style: {
          fontSize: '14px', // Adjust the font size for legend items (series names)
        },
      },
    },
    // Other options...
  });


  return (
    <Card {...other} sx={{ backgroundColor: 'transparent', boxShadow: 'none', padding: 1, paddingBottom: 0 }}>
      <Box dir="ltr">
        <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
          <Grid item xs={6}>
            <Typography sx={{ fontSize: 14 }} variant='h1'>Order Statistics</Typography>
          </Grid>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <MonthlyYearlyToggle view={view} onToggle={handleToggle} />
          </Grid>
        </Grid>
        <Grid alignSelf="center" sx={{ paddingTop: 0 }} >
          {view === 'weekly' ? (
            <ReactApexChart width={'100%'} type="line" series={weeklyChartData} options={chartOptions} height={merchant ? 500 : 350} />
          ) : (
            <ReactApexChart width={'100%'} type="line" series={monthlyChartData} options={chartOptions} height={merchant ? 500 : 350} />
          )}
        </Grid>
      </Box>
    </Card>
  );
}
